export const deleteAllValuesInObject = <T extends Record<string, string | boolean>>(obj: T) => {
    Object.keys(obj).forEach((key) => {
        obj[key as keyof T] = '' as T[keyof T]
    })
    return obj
}